import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=b492e368"
import script from "./edit.js?vue&type=script&lang=js&external"
export * from "./edit.js?vue&type=script&lang=js&external"
import style0 from "./scrollableList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports